module.exports = __webpack_public_path__ + "static/img/181002-cancer-fund.ed9a1c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/181002-cancer-fund.jpg
// module id = 7Wvc
// module chunks = 0